import {Switch, Route } from 'react-router-dom'
import OssReport from './oss-report/oss-report'
import ValidateReports from './validate-reports/validate-reports'
import SpotifyArtificialStreamFees from './spotify-artificial-stream-fees/spotify-artificial-stream-fees'
import ArtificialStreaming from './artificial-streaming/artificial-streaming'
import AppleStreamCounts from './apple-stream-counts/apple-stream-counts'
import ArtistDebt from './artist-debt/artist-debt'
import Etl from './etl/etl'
import Landing from '../landing'
import ReportAutomation from './report-automation/report-automation'
import ProtectedRoute from './protected-route'
import PeriodicSummary from './periodic-summary/periodic-summary'
import SpotifyInvoice from './spotify-invoice/spotifyInvoice'


export default function Routing(){
    return(
        <Switch>
            <ProtectedRoute exact path="/" component={Landing} />
            <ProtectedRoute path="/etl" component={Etl} />
            <ProtectedRoute path="/validate" component={ValidateReports} />
            <ProtectedRoute path="/spotifyartificialstreamfees" component={SpotifyArtificialStreamFees} />
            <ProtectedRoute path="/artificialstreaming" component={ArtificialStreaming} />
            <ProtectedRoute path="/apple-stream-counts" component={AppleStreamCounts} />
            <ProtectedRoute path="/oss" component={OssReport} />
            <ProtectedRoute path="/artistdebt" component={ArtistDebt} />
            <ProtectedRoute path="/report-automation" component={ReportAutomation} />
            <ProtectedRoute path="/periodic-summary" component={PeriodicSummary} />
            <ProtectedRoute path="/spotify-invoice-reports" component={SpotifyInvoice} />
        </Switch>
    )
}